<!-- Let's user decide if they want to open current Zoom meeting, or return to /Live -->

<template>
  <ModalDialog background="#565656" :hash="hash">
    <template #default>
      <div class="thanks">
        <h2 ref="h1Ref">Page Under Maintenance</h2>
        <p>Some videos may be briefly unavailable due to maintenance.</p>
        <p>
          If you run into issues, try again later — currently, we expect things to be back to normal
          within 24 hours.
        </p>
        <p @click="removeHash">
          <ButtonBespoke :outstanding="true">OK</ButtonBespoke>
        </p>
      </div>
    </template>
  </ModalDialog>
</template>

<script setup>
const log = (msg) => process.env.VUE_APP_DEV && console.log(`JoinMeeting: ${msg}`); // eslint-disable-line
import {ref, watch} from "vue";
import {useRoute} from "vue-router";
import ModalDialog from "@/components/ModalDialog/Index";
import ButtonBespoke from "@/components/ButtonBespoke";
import {useMaxFontSize} from "@/composables/useMaxFontSize";

const hash = "maintenance";
const route = useRoute();

const h1Ref = ref(null);
useMaxFontSize(h1Ref);

function removeHash() {
  sessionStorage.setItem("seenMaintenanceModal", "true");
  location.hash = "";
}

// watch(
//   () => route.name,
//   (newName) => {
//     log(`route.name = ${newName}`);
//     const seen = sessionStorage.getItem("seenMaintenanceModal") === "true";
//     if (!seen && newName?.match(/Video/i)) {
//       location.hash = hash;
//       sessionStorage.setItem("seenMaintenanceModal", "true");
//     }
//   },
//   {immediate: true}
// );
</script>

<style scoped>
div > * {
  color: white;
  background-color: #565656;
  padding: 20px 20px 0 20px;
}
h2 {
  font-size: 1.6rem;
  margin-bottom: 0.5rem;
}
button {
  /* font-size: var(--medium); */
  font-size: 1.4rem;
  font-weight: bold;
  line-height: 1;
}
</style>
